import agrihub from 'assets/images/general/company-logo/agrihub.png';

export const COMPANY_TYPE_USER = 3;

export const companyTypes = [
    { label: 'Commercial User', value: 1 }
    // { label: 'Platform Service User ', value: -1 },
    // // { label: 'Brokerage company', value: 2 },
    // { label: 'Data User', value: COMPANY_TYPE_USER }
];

export const companyWithExtraLogo = {
    // 'brokerage-a': agrihub,
    agrihub
};
